export default "__VITE_ASSET__ChAynfi9__"